export default __webpack_public_path__ + "static/media/insurancegig_logo.d1dbfd0f.png";